import React from 'react';
import { Outlet } from 'react-router-dom';

/**
 * Centered card layout for unauthenticated and pre-MFA flows: sign-in,
 * password reset, email verification, MFA enrollment, etc.
 */
const AuthShell = () => {
  return (
    <div
      id="dashboard-auth-layout"
      className="min-h-screen min-w-0 overflow-x-clip bg-zinc-50 font-sans antialiased text-zinc-900 dark:bg-zinc-950 dark:text-zinc-100"
    >
      <div className="flex min-h-screen flex-col items-stretch px-4 pb-[env(safe-area-inset-bottom)] pt-[env(safe-area-inset-top)] sm:px-6 lg:px-8">
        <header className="flex min-h-16 items-center justify-between">
          <div className="flex items-baseline gap-3">
            <span className="text-base font-semibold tracking-tight text-zinc-900 dark:text-white">Porsche</span>
            <span className="text-base text-zinc-500 dark:text-zinc-400">eZentrum</span>
          </div>
          <span className="text-xs uppercase tracking-wide text-zinc-600 dark:text-zinc-500">
            {process.env.REACT_APP_VERSION ? `v${process.env.REACT_APP_VERSION}` : ''}
          </span>
        </header>

        <main className="flex flex-1 items-center justify-center py-10">
          <div className="w-full max-w-md">
            <div className="rounded-2xl bg-zinc-50 p-6 ring-1 ring-zinc-200 shadow-xl sm:p-8 dark:bg-zinc-900/70 dark:ring-white/10">
              <Outlet />
            </div>
          </div>
        </main>

        <footer className="py-6 text-center text-xs text-zinc-600 dark:text-zinc-500">
          &copy; {new Date().getFullYear()} Porsche Cars North America
        </footer>
      </div>
    </div>
  );
};

export default AuthShell;
